export { BranchIndicatorsReport } from '@app/pages/Analytics/BranchIndicators/ui';
